import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { apiConfig } from '../config/api.config';

// Helper to get the XSRF token from a cookie
export function getXsrfToken() {
	const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'));
	return match ? decodeURIComponent(match[2]) : null;
}

const BaseQuery = (apiPath: string): BaseQueryFn => {
	const url =
		(import.meta.env.MODE === 'test' || apiConfig.useMocks
			? 'http://localhost'
			: apiConfig.baseUrl) + apiPath;

	return async (args, api, extraOptions: any) => {
		const includeJson = extraOptions?.includeJson !== false;
		const baseQuery = fetchBaseQuery({
			baseUrl: url,
			credentials: 'include',
			prepareHeaders: async (headers) => {
				if (includeJson) {
					headers.set('Content-Type', 'application/json');
				}

				const xsrfToken = getXsrfToken();
				if (xsrfToken) {
					headers.set('X-XSRF-TOKEN', xsrfToken);
				}
				return headers;
			},
		});

		const result = await baseQuery(args, api, extraOptions);

		return result;
	};
};

export default BaseQuery;
